import React from 'react'

import { IconSVGProps } from '@sidecar-components/atoms/Icon/Icon.types'

export const Coverage = ({
  className,
  pathClass,
  size = 6,
  ...rest
}: IconSVGProps) => (
  <svg
    aria-label="coverage icon"
    className={`h-${size} w-${size} ${className}`}
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    {...rest}
  >
    <path
      className={pathClass}
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4 13V4.0429C5.2096 3.30558 7.92392 2 12 2C16.0761 2 18.7904 3.30558 20 4.0429V13C20 15.1269 18.5277 17.3739 16.4204 19.2492C15.4083 20.1499 14.3449 20.8765 13.4467 21.3677C12.9973 21.6134 12.6146 21.7863 12.3214 21.8927C12.1554 21.953 12.051 21.9799 12 21.9916C11.949 21.9799 11.8446 21.953 11.6786 21.8927C11.3854 21.7863 11.0027 21.6134 10.5533 21.3677C9.65511 20.8765 8.59171 20.1499 7.57956 19.2492C5.47227 17.3739 4 15.1269 4 13ZM4.00001 3.91895L4 3.91947C4 3.91912 4.00001 3.91895 4.00001 3.91895ZM2.74652 2.4678C4.09458 1.60589 7.24434 0 12 0C16.7557 0 19.9054 1.60589 21.2535 2.4678C21.7454 2.78231 22 3.33374 22 3.91759V13C22 18.982 14 24 12 24C10 24 2 18.982 2 13V3.91947C2 3.33562 2.25462 2.78231 2.74652 2.4678ZM17.5607 9.54265C18.1464 8.95687 18.1464 8.00712 17.5607 7.42133C16.9749 6.83555 16.0251 6.83555 15.4393 7.42133L10.5 12.3607L8.56066 10.4213C7.97487 9.83555 7.02513 9.83555 6.43934 10.4213C5.85355 11.0071 5.85355 11.9569 6.43934 12.5427L10.5 16.6033L17.5607 9.54265Z"
    />
  </svg>
)
